module.exports = __webpack_public_path__ + "img/Group808.3d6b988c.png";